import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const declarationsCrudContract = c.router({
  savePartialData: {
    method: 'PATCH',
    path: '/declarations/:id/save-partial-data-to-declaration',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      partialDeclaration: z.any().optional(),
      partialGoodsShipmentItem: z.any().optional(),
    }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  saveDeclarationDataByLrn: {
    method: 'PATCH',
    path: '/declarations/:lrn/save-declaration-data-lrn',
    pathParams: z.object({ lrn: z.string() }),
    body: z.object({
      sequence: z.number(),
      partialDeclaration: z.any().optional(),
      partialGoodsShipmentItem: z.any().optional(),
    }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  saveDeclaration: {
    method: 'PATCH',
    path: '/declarations/:id',
    pathParams: z.object({ id: z.string() }),
    body: z.object({ declaration: z.any() }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  deleteDeclaration: {
    method: 'DELETE',
    path: '/declarations/:id',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  setCustomsControl: {
    method: 'POST',
    path: '/declarations/:id/set-customs-control',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  generateBatchByLrn: {
    method: 'POST',
    path: '/declarations/:lrn/generate-batch-by-lrn',
    pathParams: z.object({ lrn: z.string() }),
    body: z.object({
      batchName: z.string(),
      regulate: z.boolean().optional(),
      amendmentMotivation: z.string().optional(),
      amendmentReason: z.string().optional(),
    }),
    responses: {
      200: z.object({}),
    },
  },
  getPredictedDistances: {
    method: 'GET',
    path: '/declarations/:declarationId/goods-shipment-item/:goodsShipmentItemId/predicted-distances',
    pathParams: z.object({ declarationId: z.string(), goodsShipmentItemId: z.string() }),
    responses: {
      200: z.object({ data: z.array(z.any()) }),
    },
  },
  saveMultipleGoodItems: {
    method: 'PATCH',
    path: '/declarations/:id/save-multiple-good-items',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      goodItems: z.array(z.any()),
      aiModuleMustRunAfterSave: z.boolean().optional(),
      newPriceSaved: z.any().optional(),
    }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  manuallySetPrice: {
    method: 'POST',
    path: '/declarations/:id/manuallySetPrice',
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      goodItemsIds: z.array(z.string()),
      price: z.number(),
    }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  saveNotes: {
    method: 'POST',
    path: '/declarations/save-notes',
    body: z.object({
      goodsItemsIds: z.array(z.string()),
      data: z.object({
        notes: z.string(),
        customsDecisionChecked: z.boolean(),
      }),
    }),
    responses: {
      200: z.object({}),
    },
  },
});
